import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Es una dieta Keto?',
    a: 'No. Es un reseteo metabólico que usa carbohidratos estratégicos.'
  }, {
    q: '¿Necesito ir al gimnasio?',
    a: 'No. Con caminar 15 minutos después de comer es suficiente para este protocolo.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Es 100% digital. Lo recibes en tu email inmediatamente después del pago.'
  }];
  return <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-10">
      <h2 className="text-3xl font-bold text-center text-[#2D1B06] mb-10" data-id="element-11">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4" data-id="element-12">
        {faqs.map((faq, index) => <FaqItem key={index} question={faq.q} answer={faq.a} data-id="element-13" />)}
      </div>
    </section>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-[#E8820C]/20 rounded-xl overflow-hidden shadow-sm" data-id="element-14">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-15">
        <span className="font-bold text-lg text-[#2D1B06]" data-id="element-16">{question}</span>
        <ChevronDown className={`w-5 h-5 text-[#E8820C] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-17" />
      </button>

      <AnimatePresence data-id="element-18">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-19">
            <div className="p-6 pt-0 text-[#2D1B06]/80 leading-relaxed border-t border-gray-100" data-id="element-20">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}